import API from '@/utils/api/index.js';

export const useSubmitQuestionnaire = () => {
  return async (form = {}) => {
    await API.getNotApi('/sanctum/csrf-cookie');
    return API.post('/submit-questionnaire', form, null, false);
  };
};

export const useGetPrevQuestionnaire = () => {
  const route = useRoute();

  return async () => {
    const { email, token, preview } = route.query;

    if (preview || (email as string)?.startsWith('ghost+')) {
      return false;
    }

    return API.post(
      '/previous-questionnaire',
      {
        email,
        token,
      },
      null,
      false,
    );
  };
};
